var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "33. Thinking",
    id: "_33._Thinking"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M27,32H12a1,1,0,0,1-1-1V28H9a3,3,0,0,1-3-3V21.618L2.553,19.9a1,1,0,0,1-.385-1.45L6,12.691A12.995,12.995,0,0,1,29.551,5.414,1,1,0,1,1,27.93,6.586,11,11,0,0,0,8,13a1.006,1.006,0,0,1-.168.555L4.46,18.612l2.987,1.493A1,1,0,0,1,8,21v4a1,1,0,0,0,1,1h3a1,1,0,0,1,1,1v3H26V27.966a18.1,18.1,0,0,1,2.445-9.316,11,11,0,0,0,1.5-6.779,10.42,10.42,0,0,0-.287-1.62,1,1,0,0,1,1.936-.5,12.656,12.656,0,0,1,.342,1.927,12.969,12.969,0,0,1-1.775,8A16.1,16.1,0,0,0,28,27.966V31A1,1,0,0,1,27,32Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M14,28H12a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.072,19H17.928A1.931,1.931,0,0,1,16,17.189a1.927,1.927,0,0,1-2.529-.761L12.4,14.572A1.933,1.933,0,0,1,13.007,12,1.933,1.933,0,0,1,12.4,9.428l1.072-1.856A1.927,1.927,0,0,1,16,6.811,1.931,1.931,0,0,1,17.928,5h2.144A1.929,1.929,0,0,1,22,6.811a1.927,1.927,0,0,1,2.53.762L25.6,9.428h0A1.933,1.933,0,0,1,24.993,12a1.933,1.933,0,0,1,.606,2.571l-1.073,1.857a1.928,1.928,0,0,1-2.53.761A1.929,1.929,0,0,1,20.072,19ZM18,17h2a1.929,1.929,0,0,1,2.828-1.634l1-1.733a1.928,1.928,0,0,1,0-3.266l-1-1.733A1.929,1.929,0,0,1,20,7H18a1.929,1.929,0,0,1-2.828,1.633l-1,1.734a1.928,1.928,0,0,1,0,3.266l1,1.734A1.929,1.929,0,0,1,18,17Zm4.893-1.6Zm2-3.339Zm-2.1-3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,14a2,2,0,1,1,2-2A2,2,0,0,1,19,14Zm0-2v0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.cd24d2e05ec422d68fe46a5303b31479.svg";
export { ForwardRef as ReactComponent };